import { ca } from '@cian/analytics';

import { IBankDesktopSchema } from '../../repositories/newbuilding-card/entities/newbuilding/BankDesktopSchema';
import { getNewbuildingProduct } from '../../utils/analytics';

export function trackAccreditedBanksToListingClick(bank: IBankDesktopSchema, newbuildingId: number) {
  ca('eventSite', {
    action: 'click_accredited_banks',
    category: 'Promo',
    label: 'to_listingjk',
    name: 'oldevent',
    products: [
      getNewbuildingProduct({
        newbuildingId,
        extra: {
          bankId: bank.id,
          bank_name: bank.name,
        },
      }),
    ],
  });
}
